import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/ArrowDropUp';

class ArrowDropUpIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default ArrowDropUpIcon;
